export const SUPPLIER_TABLE_EMPTY = {
  packages: {
    icon: "fi fi-rr-box",
    title: "No package groups yet",
    description:
      "Create a package group to start adding tour combinations, pricing, and availability.",
    filteredTitle: "No package groups match your filters",
    addLabel: "Add package",
  },
  events: {
    icon: "fi fi-rr-calendar",
    title: "No events yet",
    description: "Create your first event to start managing schedules, pricing, and bookings.",
    filteredTitle: "No events match your filters",
    addLabel: "Add Event",
  },
  activities: {
    icon: "fi fi-rr-hiking",
    title: "No activities yet",
    description: "Add an activity to define experiences, pricing, and availability for guests.",
    filteredTitle: "No activities match your filters",
    addLabel: "Add Activity",
  },
  attractions: {
    icon: "fi fi-rr-map-marker",
    title: "No attractions yet",
    description: "Create your first attraction to manage timings, pricing, and visitor details.",
    filteredTitle: "No attractions match your filters",
    addLabel: "Add Attraction",
  },
  rentals: {
    icon: "fi fi-rr-key",
    title: "No rental items yet",
    description: "Add a rental item to list equipment, vehicles, or gear for booking.",
    filteredTitle: "No rental items match your filters",
    addLabel: "Add Rental Item",
  },
  suitable: {
    icon: "fi fi-rr-users",
    title: "No suitable-for options yet",
    description: "Add suitable-for options to tag who your packages and tours are best for.",
    filteredTitle: "No suitable-for options match your search",
    addLabel: "Add Suitable For",
  },
  inclusions: {
    icon: "fi fi-rr-list-check",
    title: "No inclusions yet",
    description: "Add inclusions to highlight what is covered in your packages and tours.",
    filteredTitle: "No inclusions match your search",
    addLabel: "Add Inclusion",
  },
  hotels: {
    icon: "fi fi-rr-building",
    title: "No hotels yet",
    description: "Add hotels to build your accommodation master list for packages.",
    filteredTitle: "No hotels match your search",
    addLabel: "Add Hotel",
  },
  packageAttractions: {
    icon: "fi fi-rr-map-marker",
    title: "No package attractions yet",
    description: "Add attractions to your master list for use in package itineraries.",
    filteredTitle: "No attractions match your search",
    addLabel: "Add Attraction",
  },
  transactions: {
    icon: "fi fi-rr-receipt",
    title: "No transactions yet",
    description: "Payment transactions from bookings will appear here once customers pay.",
    filteredTitle: "No transactions match your filters",
  },
  enquiries: {
    icon: "fi fi-rr-envelope",
    title: "No enquiries yet",
    description: "Customer enquiries submitted through your listings will show up here.",
    filteredTitle: "No enquiries match your search",
  },
  attractionCategory: {
    icon: "fi fi-rr-folder",
    title: "No attraction categories yet",
    description: "Create categories to group attractions and keep your catalog organized.",
    filteredTitle: "No categories match your search",
    addLabel: "Add New Category",
  },
  rentalCategory: {
    icon: "fi fi-rr-folder",
    title: "No rental categories yet",
    description: "Create rental categories to organize items by type, such as vehicles or gear.",
    filteredTitle: "No categories match your search",
    addLabel: "Add New Category",
  },
  rentalSubCategory: {
    icon: "fi fi-rr-folder",
    title: "No sub categories yet",
    description: "Add sub categories under a parent category to refine your rental catalog.",
    filteredTitle: "No sub categories match your filters",
    addLabel: "Add New Sub Category",
  },
  packageBookings: {
    icon: "fi fi-rr-ticket",
    title: "No package bookings yet",
    description: "Bookings for your tour packages will appear here once customers reserve.",
    filteredTitle: "No package bookings match your search",
  },
  eventBookings: {
    icon: "fi fi-rr-ticket",
    title: "No event bookings yet",
    description: "Event ticket bookings will show up here after customers complete checkout.",
    filteredTitle: "No event bookings match your search",
  },
  activityBookings: {
    icon: "fi fi-rr-ticket",
    title: "No activity bookings yet",
    description: "Activity reservations will appear here once guests book your experiences.",
    filteredTitle: "No activity bookings match your search",
  },
  attractionBookings: {
    icon: "fi fi-rr-ticket",
    title: "No attraction bookings yet",
    description: "Attraction visit bookings will be listed here after customers book.",
    filteredTitle: "No attraction bookings match your search",
  },
  rentalBookings: {
    icon: "fi fi-rr-ticket",
    title: "No rental bookings yet",
    description: "Rental reservations will show here once customers book your items.",
    filteredTitle: "No rental bookings match your search",
  },
  rentalManagement: {
    icon: "fi fi-rr-briefcase",
    title: "No rental bookings yet",
    description: "Rental booking requests and confirmations will appear in this list.",
    filteredTitle: "No rental bookings match your filters",
  },
};

export function getTableEmptyProps(key, overrides = {}) {
  return { ...(SUPPLIER_TABLE_EMPTY[key] || {}), ...overrides };
}
